import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EmailIcon from '@mui/icons-material/Email';
import {checkStringProperty} from "../../../utility/componentUtil";
import CCOAccordion from "../../fundamentals/CCOAccordion";
import CCOLinkText, {type} from "../../fundamentals/CCOLinkText";
import {usePageContext} from "../../../context/PageContext";
import C051BankData from "../C051BankData/C051BankData";
import useWindowSize from "../../../utility/useWindowSize";
import {useTranslation} from "react-i18next";
import type {CAEGlobalSettings} from "../../../types/CAEGlobalSettings";
import {createLinkClickHandler} from "tracking/handlers/linkClickHandler";


interface Props {
    CAEGlobalSettings: CAEGlobalSettings,
    padding?: number | string,
}

function C050BankContactData(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize();
    const {t} = useTranslation();
    const pageContext = usePageContext();

    const phone = props.CAEGlobalSettings["sos-phone"];
    const mail = props.CAEGlobalSettings["sos-email"];

    const accountSettings = pageContext.page?.accountSettings;
    const emailLabel = accountSettings?.["sos-email-alternative-label"] ||
        props.CAEGlobalSettings["sos-email-alternative-label"] ||
        t("c050_email_alt_label");

    const box = <Box sx={{
        display: 'grid',
        alignSelf: 'start',
        padding: props.padding,
    }}>
        <Typography variant="h4" sx={{
            marginBottom: 2
        }}>Kontakt</Typography>
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
                gap: 1,
                py: 0
            }}>
            <PhoneIphoneIcon fontSize={"small"} sx={{color: "footerLink.main"}}/>
            {
                phone ? <a data-cypress='phoneContact' data-cypress-additional={`tel:${phone}`}
                           href={`tel:${phone}`}
                           onClick={createLinkClickHandler({
                               href: `tel:${phone}`,
                               linkTarget: "_self",
                           })}
                >
                    <CCOLinkText type={type.FOOTER} txt={phone}/>
                </a> : null
            }
        </Stack>
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
                gap: 1
            }}>
            <EmailIcon fontSize={"small"} sx={{color: "footerLink.main"}}/>
            {
                mail ? <a data-cypress='mailContact' data-cypress-additional={`mailto:${mail}`}
                          href={`mailto:${mail}`}
                          onClick={createLinkClickHandler({
                              href: `mailto:${mail}`,
                              linkTarget: "_self",
                          })}>
                    <CCOLinkText type={type.FOOTER} txt={mail.length <= 26 ? mail : emailLabel}/>
                </a> : null
            }
        </Stack>

        <C051BankData CAEGlobalSettings={props.CAEGlobalSettings} iconColor="footerLink.main"/>

        <Box data-cypress='paypalButton' sx={{mt: 2}}
             dangerouslySetInnerHTML={{
                 __html: checkStringProperty(
                     props.CAEGlobalSettings["sos-paypal-custom-button-markup"])
             }}/>
    </Box>

    return (<>
            {lowerThanWindowLarge ? <CCOAccordion title={"Kontakt"} initiallyExpanded
                                                  sx={{
                                                      backgroundColor: 'transparent',
                                                      borderTop: 'none'
                                                  }}>
                    {box}
                </CCOAccordion>
                : box
            }
        </>
    )
}

export default C050BankContactData;